module.exports = __webpack_public_path__ + "img/btn-bg-white.png?6c572816213180721d5f9a412f7ad958";